module.exports = __webpack_public_path__ + "static/media/bottom.cb9a90cd.png";